// ════════════════════════════════════════════════════════════
// Shell store (Zustand persist) — Sprint Shell
// ════════════════════════════════════════════════════════════
// État UI du shell, persistant entre sessions (localStorage) :
//   - sidebarCollapsed : sidebar desktop repliée (icônes seules)
//   - recentPages      : 5 dernières pages visitées (CommandPalette)
//
// Le theme reste dans useAppStore. L'auth dans useAuthStore.
// ════════════════════════════════════════════════════════════
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface RecentPage {
  /** Pathname complet (clé de déduplication). */
  path: string;
  /** Libellé lisible (titre de la page / item de nav). */
  label: string;
}

const MAX_RECENT = 5;

interface ShellState {
  sidebarCollapsed: boolean;
  recentPages: RecentPage[];
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  /** Enregistre une page visitée (dédupliquée, plafonnée à 5, plus récente en tête). */
  pushRecentPage: (page: RecentPage) => void;
}

export const useShellStore = create<ShellState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      recentPages: [],
      toggleSidebar: () => {
        set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed }));
      },
      setSidebarCollapsed: (sidebarCollapsed) => {
        set({ sidebarCollapsed });
      },
      pushRecentPage: (page) => {
        set((s) => {
          const deduped = s.recentPages.filter((p) => p.path !== page.path);
          return { recentPages: [page, ...deduped].slice(0, MAX_RECENT) };
        });
      },
    }),
    {
      name: 'ecr-shell-state',
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);
